import * as React from 'react';

class Tiere extends React.Component {

    public render() {
        return (
            <div>
                Tiere
            </div>
        );
    }
}

export default Tiere;



// WEBPACK FOOTER //
// ./src/Tiere/Tiere.tsx